@import '~@s-ui/theme/lib/settings-compat-v7/index';
@import '~@s-ui/theme/lib/index';
@import '~@adv-mt/mt-theme/lib/motor';

@import '~@adv-mt/mt-card-appraisal/lib/index';
@import '~@adv-mt/mt-card-message/lib/index';
@import '~@adv-mt/mt-form-conditions-and-privacy-checkbox/lib/index';
@import '~@adv-mt/mt-form-sell-vehicle/lib/index';
@import '~@adv-mt/mt-form-user-contact/lib/index';
@import '~@adv-mt/mt-hero-basic/lib/index';
@import '~@adv-mt/mt-layout-basic/lib/index';
@import '~@adv-mt/mt-list-basic/lib/index';
@import '~@adv-mt/mt-markdown-wrapper/lib/index';
@import '~@adv-mt/mt-navigation-breadcrumb/lib/index';
@import '~@adv-mt/mt-panel-market-players/lib/index';
@import '~@adv-mt/mt-perf-dynamic-rendering/lib/index';
@import '~@adv-mt/mt-svg-icons/lib/index';
@import '~@adv-mt/mt-title-basic/lib/index';
@import '~@s-ui/react-atom-button/lib/index';
@import '~@s-ui/react-atom-icon/lib/index';
@import '~@s-ui/react-atom-image/lib/index';
@import '~@s-ui/react-form-builder/lib/index';
@import '~@s-ui/react-layout-grid/lib/index';
@import '~@s-ui/react-molecule-accordion/lib/index';
@import '~@s-ui/react-molecule-notification/lib/index';
@import '~@s-ui/react-molecule-quick-action/lib/index';

@import '../components/AccordionFaqs/index.scss';
@import '../components/CardsBenefits/index.scss';
@import '../components/FormInstantOffer/index.scss';
@import '../components/TopBar/index.scss';

.mt-LandingInstantOffer {
  background-color: $c-white;

  .mt-HeroBasic--withTopbar {
    padding-top: 0px;
  }
}
